// @flow
import React from 'react';
import { SiVisa, SiMastercard } from 'react-icons/si';
import { FaStripe, FaCcPaypal } from 'react-icons/fa';

type Props = {
  name: string,
  size: string,
  style: string,
  title: string,
  color: string,
};

const PaymentIcon = ({
  size,
  style,
  title,
  name = 'visa',
  color = 'black',
}: Props) => {
  switch (name) {
    case 'visa':
      return <SiVisa size={size} style={style} title={title} color={color} />;
    case 'mastercard':
      return (
        <SiMastercard size={size} style={style} title={title} color={color} />
      );
    case 'stripe':
      return <FaStripe size={size} style={style} title={title} color={color} />;
    case 'paypal':
      return (
        <FaCcPaypal size={size} style={style} title={title} color={color} />
      );
    default:
      return <SiVisa size={size} style={style} title={title} color={color} />;
  }
};

export default PaymentIcon;
